"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _typographyStylex = require("web/shared/typography.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * The chrome every jobs view renders inside: the page column, the nav, the
 * heading, and the one control that belongs to the frame rather than to a
 * view.
 *
 * The console is a tool, not a reading surface: its tables want the screen, so
 * the layout runs nearly edge to edge and only starts holding a margin on very
 * wide displays.
 */
const styles = exports.styles = {
  page: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    flexGrow: "x1iyjqo2",
    width: "xh8yej3",
    boxSizing: "x9f619",
    maxWidth: "x1oqmd8z",
    marginLeft: "x8x9d4c",
    marginInlineStart: null,
    marginInlineEnd: null,
    marginRight: "xack27t",
    $$css: true
  },
  section: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    width: "xh8yej3",
    $$css: true
  },
  header: {
    display: "x78zum5",
    alignItems: "x1pha0wt",
    justifyContent: "x1qughib",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    flexWrap: "x1a02dak",
    $$css: true
  },
  heading: {
    fontFamily: "xm3uy08",
    fontSize: "x1uv3qv7",
    fontWeight: "x1s688f",
    marginTop: "xdj266r",
    marginBottom: "xhbfen4",
    color: "x10kmngs",
    $$css: true
  },
  intro: {
    fontSize: "x1q2zfhj",
    marginTop: "xdj266r",
    marginBottom: "xyi6m4r",
    color: "xcdm7ny",
    $$css: true
  },
  nav: {
    display: "x78zum5",
    paddingTop: "x1q57ora",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    flexWrap: "x1a02dak",
    marginBottom: "x1nhhxel",
    $$css: true
  },
  navLink: {
    fontFamily: "xm3uy08",
    fontSize: "x9bimuu",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    color: "xcdm7ny",
    paddingTop: "xi1zy7b",
    paddingBottom: "xvrpxjx",
    paddingLeft: "x79ra4s",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x33uob6",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x1e6avla",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    $$css: true
  },
  navLinkActive: {
    color: "x10kmngs",
    backgroundColor: "xkjg22i",
    $$css: true
  },
  button: {
    fontFamily: "x1wl88yq",
    fontSize: "x1q2zfhj",
    cursor: "x1ypdohk",
    color: "x10kmngs",
    backgroundColor: "xjbqb8w",
    paddingTop: "x1sr71sp",
    paddingBottom: "xpcrps7",
    paddingLeft: "x1430pes",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xomf1ax",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x1e6avla",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    $$css: true
  },
  backLink: {
    display: "x1rg5ohu",
    fontSize: "x1q2zfhj",
    color: "xcdm7ny",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    marginBottom: "xyi6m4r",
    $$css: true
  }
};